import { Body3 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import i18n from '@flatsy/utils/translations'
import clsx from 'clsx'
import React from 'react'
import { useStyles } from './Style'

const ArrowStep3: React.FC<{ show?: boolean }> = ({ show }): React.ReactElement => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.container, classes.step3, show && 'active')}>
      <img src={FlatsyTheme.image.arrowStep3} className={classes.arrow} alt="arrow" />
      <div className={classes.stepNumber}>
        <Body3 className={classes.stepNumberInner}>3</Body3>
      </div>
      <Body3 className={classes.stepInformation}>
        {i18n.t('here_you_can_see_what_is_missing')}
      </Body3>
    </div>
  )
}

export default ArrowStep3
